import React, { useEffect, useState } from 'react';
import CustomizeTableColumnsModal from '../../components/customizeTableColumnsModal';
import CompareCustomerReportModel from '../../components/compareCustomerReportModal';
import ScheduleReportModal from '../../components/scheduleReportModal';
import { DATE_RANGE, formatDateDDMMYYYY, getDateRange } from '../../../../../utils/constant';
import ReportTableComponent from '../../components/reportTableComponent';
import ReportSubHeaderComponent from '../../components/reportSubHeaderComponent';
import ReportHeaderComponent from '../../components/reportHeaderComponent';
import compareIcon from '../../../../../assets/image/compare-icon.svg';
import favIcon from '../../../../../assets/image/fav-icon.svg';
import favActiveIcon from '../../../../../assets/image/fav_icon_color.svg';
import customizeIcon from '../../../../../assets/image/customize-icon.svg';
import { toast } from 'react-toastify';
import {
	addFavouriteReport,
	downloadPdfReport,
	exportExcelReport,
	getSalesSummaryReport,
	removeFavouriteReport,
} from '../../../../../services/reports';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { parseDate } from '../../../../../utils/utility';

export default function SaleBySalesSummary({ activeTab, setIsCollapse, isCollapse }) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [isLoaderSalesSummaryReport, setLoaderSalesSummaryReport] = useState(false);
	const [isScheduleModelOpen, setIsScheduleModelOpen] = useState(false);
	const [compareModelOpen, setCompareModelOpen] = useState(false);
	const [customizeColumnsModel, setCustomizeColumnsModal] = useState(false);
	const [CustomDateRange, setCustomDateRange] = useState([null, null]);
	const [customerReportList, setCustomerReport] = useState([]);
	const [metaData, setMetaData] = useState([]);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const [scheduledId, setScheduledId] = useState(null);
	const [isFavReport, setIsFavReport] = useState(false);
	const [sortDirection, setSortDirection] = useState({});
	const [dropdownState, setDropdownState] = useState({
		date_range: false,
		transaction_type: false,
		isCustomDateOpen: false,
	});
	const [isLoading, setLoading] = useState({
		pdf: false,
		excel: false,
		isLoader: false,
	});

	const [params, setParams] = useState({
		date_range: searchParams.get('date_range') || 'this_month',
		compare_type: searchParams.get('compare_type') || null,
		compare_count: searchParams.get('compare_count') || null,
		start_date: searchParams.get('start_date') || null,
		end_date: searchParams.get('end_date') || null,
		sort_by: searchParams.get('sort_by') || 'product_name',
		order_by: searchParams.get('order_by') || 'desc',
		page: Number(searchParams.get('page')) || 1,
		page_size: Number(searchParams.get('page_size')) || 100000,
		is_arrange_year_period: searchParams.get('is_arrange_year_period') || false,
	});
	const [startDate, endDate] = CustomDateRange;
	const customerAvailableTableColumnsList = [
		{ key: 'invoice_count', label: 'INVOICE COUNT', type: 'number' },
		{ key: 'credit_note_count', label: 'CREDIT NOTE COUNT', type: 'number' },
		{ key: 'credit_note_amount', label: 'CREDIT NOTE AMOUNT', type: 'currency' },
		{ key: 'credit_note_amount_with_tax', label: 'CREDIT NOTE AMOUNT WITH TAX', type: 'currency' },
		{ key: 'balance_due', label: 'BALANCE DUE', type: 'currency' },
		{ key: 'discount_amount', label: 'DISCOUNT AMOUNT', type: 'currency' },
		{ key: 'quantity_sold', label: 'QUANTITY SOLD', type: 'number' },
		{ key: 'item_count', label: 'ITEM COUNT', type: 'number' },
		{ key: 'total_sales', label: 'TOTAL SALES', type: 'currency' },
		{ key: 'total_sales_with_tax', label: 'TOTAL SALES WITH TAX', type: 'currency' },
		{ key: 'total_tax_amount', label: 'TOTAL TAX AMOUNT', type: 'currency' },
	];
	const [selectedColumnsList, setSelectedColumnsList] = useState([
		{ key: 'invoice_count', label: 'INVOICE COUNT', type: 'number' },
		{ key: 'total_sales', label: 'TOTAL SALES', type: 'currency' },
		{ key: 'total_sales_with_tax', label: 'TOTAL SALES WITH TAX', type: 'currency' },
		{ key: 'total_tax_amount', label: 'TOTAL TAX AMOUNT', type: 'currency' },
	]);
	useEffect(() => {
		if (startDate && endDate) {
			setParams((prev) => ({
				...prev,
				start_date: formatDateDDMMYYYY(startDate),
				end_date: formatDateDDMMYYYY(endDate),
			}));
		}
	}, [startDate, endDate]);

	const getSummaryReportList = async (param = null) => {
		try {
			setLoaderSalesSummaryReport(true);
			const res = await getSalesSummaryReport(param || params);
			if (res.success) {
				const { report, isFavourate, schedulerID } = res.data;
				setIsFavReport(isFavourate);
				setScheduledId(schedulerID);
				if (report) {
					const { data, meta } = report;
					setMetaData(meta);
					if (data) {
						setCustomerReport(data);
					}
				}
			} else {
				toast.error(res.message);
			}
		} catch {
		} finally {
			setLoaderSalesSummaryReport(false);
		}
	};

	const handleDownloadPdf = async () => {
		try {
			setLoading((prev) => ({
				...prev,
				pdf: true,
				isLoader: true,
			}));
			let data;
			data = {
				compare_type: params.compare_type,
				compare_count: params.compare_count,
				...(params.date_range === 'custom'
					? { start_date: params.start_date, end_date: params.end_date }
					: { date_range: params.date_range }),
			};
			const res = await downloadPdfReport('summary', data);
			if (res.success) {
				const { signed_url } = res.data;
				window.open(signed_url, '_blank');
				toast.success('Sale By Sales Summary report is printed successfully');
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoading((prev) => ({
				...prev,
				pdf: false,
				isLoader: false,
			}));
		}
	};

	const handleExportExcel = async () => {
		try {
			setLoading((prev) => ({
				...prev,
				excel: true,
				isLoader: true,
			}));
			let data;
			data = {
				compare_type: params.compare_type,
				compare_count: params.compare_count,
				...(params.date_range === 'custom'
					? { start_date: params.start_date, end_date: params.end_date }
					: { date_range: params.date_range }),
			};
			const res = await exportExcelReport('summary', data);
			if (res.success) {
				const a = document.createElement('a');
				a.href = res.data.signed_url;
				a.download = `summary_report_table.xlsx`;
				document.body.appendChild(a);
				a.click();
				a.remove();
				toast.success(res.message);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
		} finally {
			setLoading((prev) => ({
				...prev,
				excel: false,
				isLoader: false,
			}));
		}
	};

	const handleFavReport = async () => {
		try {
			const body = {
				report_key: activeTab.toLowerCase().replaceAll(' ', '_'),
			};
			const res = await addFavouriteReport(body);
			if (res.success) {
				toast.success(res.message);
				setIsFavReport(!isFavReport);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {}
	};

	const handleRemoveFavReport = async () => {
		try {
			const res = await removeFavouriteReport(activeTab.toLowerCase().replaceAll(' ', '_'));
			if (res.success) {
				toast.success(res.message);
				setIsFavReport(!isFavReport);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {}
	};

	const setFilterFromUrl = () => {
		setSortDirection({
			[searchParams.get('sort_by')]: searchParams.get('order_by') || '',
		});
		if (searchParams.get('date_range') === 'custom') {
			setCustomDateRange([
				searchParams.get('start_date') ? parseDate(searchParams.get('start_date')) : null,
				searchParams.get('end_date') ? parseDate(searchParams.get('end_date')) : null,
			]);
			setDropdownState((prev) => ({
				...prev,
				isCustomDateOpen: true,
			}));
		}
	};

	useEffect(() => {
		setFilterFromUrl();
	}, []);

	const setUrlSearchParams = () => {
		const url = new URLSearchParams();
		Object.entries(params).forEach(([key, value]) => {
			if (value !== null && value !== undefined) {
				url.set(key, value);
			}
		});
		setSearchParams(url);
	};

	useEffect(() => {
		setUrlSearchParams();
	}, [params]);

	useEffect(() => {
		getSummaryReportList();
	}, [params.sort_by, params.order_by, params.group_by]);

	return (
		<div>
			<div>
				<div style={{ backgroundColor: '#FFF', position: 'sticky', top: 0, zIndex: 100 }}>
					<ReportHeaderComponent
						title={'Sales'}
						subtitle={true}
						favIconButton={{
							fav_icon: isFavReport ? favActiveIcon : favIcon,
							handler: () => {
								if (isFavReport) {
									handleRemoveFavReport();
								} else {
									handleFavReport();
								}
							},
						}}
						setIsCollapse={setIsCollapse}
						isCollapse={isCollapse}
						activeTab={activeTab}
						fromDate={
							params.date_range !== null && params.date_range !== 'custom'
								? getDateRange(params.date_range).from
								: startDate !== null
									? startDate
									: ''
						}
						toDate={
							params.date_range !== null && params.date_range !== 'custom'
								? getDateRange(params.date_range).to
								: endDate !== null
									? endDate
									: ''
						}
						buttons={[
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Schedule Report',
								isDropdown: false,
								disabled: false,
								handler: () => {
									setIsScheduleModelOpen(true);
								},
							},
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Print/Download',
								loader: isLoading.isLoader && isLoading.pdf,
								disabled: isLoading.isLoader && isLoading.pdf,
								handler: () => handleDownloadPdf(),
							},
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Send Email',
								disabled: false,
								handler: () =>
									navigate(
										`/user/${suburl}/reports/send-emails/${activeTab.toLowerCase().replaceAll(' ', '_')}`,
										{ state: { filter: params } },
									),
							},
							{
								className: 'btn-gray mt-0 px-4 ',
								button: 'Export to Excel',
								loader: isLoading.isLoader && isLoading.excel,
								disabled: isLoading.isLoader && isLoading.excel,
								handler: () => handleExportExcel(),
							},
						]}
					/>
					<ReportSubHeaderComponent
						getReportList={getSummaryReportList}
						params={params}
						setParams={setParams}
						startDate={startDate}
						endDate={endDate}
						setCustomDateRange={setCustomDateRange}
						dropdownState={dropdownState}
						setDropdownState={setDropdownState}
						filters={[
							{
								type: 'dropdown',
								label: 'Date Range',
								key: 'date_range',
								options: DATE_RANGE,
								isCustom: true,
							},
						]}
					/>
				</div>
				<ReportTableComponent
					activeTab={activeTab}
					reportList={customerReportList}
					isLoader={isLoaderSalesSummaryReport}
					metaData={metaData}
					selectedColumnsList={selectedColumnsList}
					params={params}
					setParams={setParams}
					sortDirection={sortDirection}
					setSortDirection={setSortDirection}
					fromDate={
						params.date_range !== null && params.date_range !== 'custom'
							? getDateRange(params.date_range).from
							: startDate !== null
								? startDate
								: ''
					}
					toDate={
						params.date_range !== null && params.date_range !== 'custom'
							? getDateRange(params.date_range).to
							: endDate !== null
								? endDate
								: ''
					}
					actions={[
						{
							key: 'compare',
							label: 'Compare with',
							isOpenDropdown: false,
							dropdownValue: '',
							icon: compareIcon,
							onClick: () => setCompareModelOpen(true),
							showArrow: true,
						},
						{
							key: 'customize',
							label: 'Customize Table Columns',
							icon: customizeIcon,
							isOpenDropdown: false,
							dropdownValue: '',
							showArrow: false,
							onClick: () => setCustomizeColumnsModal(true),
						},
					]}
				/>
			</div>
			{isScheduleModelOpen && (
				<ScheduleReportModal
					isScheduleModelOpen={isScheduleModelOpen}
					setIsScheduleModelOpen={setIsScheduleModelOpen}
					activeTab={activeTab}
					id={scheduledId}
				/>
			)}
			{compareModelOpen && (
				<CompareCustomerReportModel
					compareModelOpen={compareModelOpen}
					params={params}
					setCompareModelOpen={setCompareModelOpen}
					setParams={setParams}
					getReportList={getSummaryReportList}
				/>
			)}
			{customizeColumnsModel && (
				<CustomizeTableColumnsModal
					isOpenModal={customizeColumnsModel}
					setIsOpenModal={setCustomizeColumnsModal}
					availableColumnsList={customerAvailableTableColumnsList}
					selectedColumsList={selectedColumnsList}
					setSelectedColumnsList={setSelectedColumnsList}
					setParams={setParams}
					params={params}
					getReportList={getSummaryReportList}
				/>
			)}
		</div>
	);
}
